import React, { useMemo } from "react";
import {
  createSearchParams,
  Navigate,
  NavLink,
  NavLinkProps,
  useLocation,
} from "react-router";
import { AnyObject } from "@triare/auth-redux";
import {
  DashboardOutlined,
  FormOutlined,
  HistoryOutlined,
  LogoutOutlined,
  MailOutlined,
  MessageOutlined,
  StarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu as AntdMenu } from "antd";
import { connect } from "react-redux";
import { signOut } from "@triare/auth-redux/dist/saga/auth/signOut";
import { Route } from "../../../routes";
import store, { RootState } from "../../../store";
import { moduleName, useAuth, User } from "../../../store/auth";
import { useSimpleModal } from "../../Common/Modal/Simple";
import { doesUserHaveAccess } from "../../../routes/PrivateRoute";
import SignIn from "../../../pages/Auth/SignIn";
import ForgotPassword from "../../../pages/Auth/ForgotPassword";
import ResetPassword from "../../../pages/Auth/ResetPassword";
import SignUp from "../../../pages/Auth/SignUp";
import Information from "../../../pages/Auth/SignUp/Information";
import ConfirmEmail from "../../../pages/Auth/ConfirmEmail";
import Chat from "../../../pages/Chat";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";
import Users from "../../../pages/Users";
import UsersCreate from "../../../pages/Users/create";
import UsersEdit from "../../../pages/Users/edit";
import NotificationCentre from "../../../pages/NotificationCenter";
import Dashboard from "../../../pages/Dashboard";
import Reviews from "../../../pages/Reviews";

import styles from "./index.module.scss";
import LogHistory from "../../../pages/LogHistory";
import Campaigns from "../../../pages/Campaigns";
import Survey from "../../../pages/Survey";
import SurveyCreate from "../../../pages/Survey/create";
import SurveyEdit from "../../../pages/Survey/edit";

export interface MenuRoute extends Route {
  ignoreMenu?: boolean;

  children?: MenuRoute[];
  /** If translation key passed - menu will use text from i18n config. If not - use 'name' from route */
  translationKey?: string;
}

export const routes: MenuRoute[] = [
  // {
  //   privateRoute: true,
  //   name: "Sign In",
  //   translationKey: "routes.signIn",
  //   align: "left",
  //   icon: <LoginOutlined />,
  //   route: {
  //     path: "sign-in",
  //     element: <SignIn />,
  //   },
  // },
  // {
  //   name: "Sign Up",
  //   translationKey: "routes.signUp",
  //   icon: <FormOutlined />,
  //   align: "left",
  //   route: {
  //     path: "sign-up",
  //     element: <SignUp />,
  //   },
  //   children: [
  //     {
  //       ignoreMenu: true,
  //       name: "Information",
  //       route: {
  //         path: "information",
  //         element: <Information />,
  //       },
  //     },
  //   ],
  // },
  // {
  //   name: "Forgot password",
  //   translationKey: "routes.forgotPassword",
  //   icon: <LockOutlined />,
  //   align: "left",
  //   route: {
  //     path: "forgot-password",
  //     element: <ForgotPassword />,
  //   },
  // },
  // {
  //   name: "Reset password",
  //   translationKey: "routes.resetPassword",
  //   icon: <LogoutOutlined />,
  //   align: "left",
  //   route: {
  //     path: "reset-password/:secretKey",
  //     element: <ResetPassword />,
  //   },
  // },
  // {
  //   name: "Confirm email",
  //   translationKey: "routes.confirmEmail",
  //   icon: <HomeOutlined />,
  //   align: "left",
  //   route: {
  //     path: "complete-registration/:mode/:secretKey",
  //     element: <ConfirmEmail />,
  //   },
  // },
  // {
  //   name: "Confirm email (set a password)",
  //   translationKey: "routes.confirmEmailSetPassword",
  //   icon: <LogoutOutlined />,
  //   align: "left",
  //   route: {
  //     path: "complete-registration-test/password/:secretKey",
  //     element: <ConfirmEmail mode="password" />,
  //   },
  // },
  {
    privateRoute: true,
    name: "Dashboard",
    translationKey: "routes.dashboard",
    icon: <DashboardOutlined />,
    align: "left",
    route: {
      path: "dashboard",
      element: <Dashboard />,
    },
  },

  {
    privateRoute: true,
    name: "Users",
    translationKey: "routes.users",
    align: "left",
    icon: <UserOutlined />,
    route: {
      path: "users",
      element: <Users />,
    },
    children: [
      {
        ignoreMenu: true,
        privateRoute: true,
        name: "Create Users",
        route: {
          path: "create",
          element: <UsersCreate />,
        },
      },
      {
        ignoreMenu: true,
        privateRoute: true,
        name: "Users redirect to edit",
        route: {
          path: ":id",
          element: <Navigate to="edit" replace />,
        },
        children: [
          {
            ignoreMenu: true,
            // privateRoute: true,
            name: "Edit Users",
            route: {
              path: "edit",
              element: <UsersEdit />,
            },
          },
        ],
      },
    ],
  },
  {
    privateRoute: true,
    name: "Notifications",
    align: "left",
    icon: <MessageOutlined />,
    translationKey: "routes.notificationCentre",
    route: {
      path: "notification-center",
      element: <NotificationCentre />,
    },
  },
  {
    privateRoute: true,
    name: "Reviews",
    translationKey: "routes.reviews",
    icon: <StarOutlined />,
    align: "left",
    route: {
      path: "reviews",
      element: <Reviews />,
    },
  },
  {
    privateRoute: true,
    name: "Log History",
    translationKey: "routes.logHistory",
    icon: <HistoryOutlined />,
    align: "left",
    route: {
      path: "log-history",
      element: <LogHistory />,
    },
  },
  {
    // Access copied from the entries around it — every section in this menu is
    // simply privateRoute, with no role gating. See DEVELOPER_TASKS.md.
    privateRoute: true,
    name: "Campaigns",
    translationKey: "routes.campaigns",
    align: "left",
    icon: <MailOutlined />,
    route: {
      path: "campaigns",
      element: <Campaigns />,
    },
  },

  {
    privateRoute: true,
    name: "Survey",
    translationKey: "Survey",
    align: "left",
    icon: <FormOutlined />,
    route: {
      path: "survey",
      element: <Survey />,
    },
    children: [
      {
        ignoreMenu: true,
        privateRoute: true,
        name: "Create Survey",
        route: {
          path: "create",
          element: <SurveyCreate />,
        },
      },
      {
        ignoreMenu: true,
        privateRoute: true,
        name: "Survey redirect to edit",
        route: {
          path: ":id",
          element: <Navigate to="edit" replace />,
        },
        children: [
          {
            ignoreMenu: true,
            // privateRoute: true,
            name: "Edit Survey",
            route: {
              path: "edit",
              element: <SurveyEdit />,
            },
          },
        ],
      },
    ],
  },
  // {
  //   privateRoute: true,
  //   name: "Chat",
  //   translationKey: "routes.chat",
  //   icon: <LogoutOutlined />,
  //   align: "left",
  //   route: {
  //     path: "chat",
  //     element: <Chat />,
  //   },
  // },
  /* * */
  // {
  //   privateRoute: true,
  //   align: "right",
  //   icon: <UserOutlined style={{ fontSize: 18 }} />,
  //   className: "icon-padding-mini-sub",
  //   children: [
  //     {
  //       privateRoute: true,
  //       icon: <LogoutOutlined />,
  //       name: "Sign out",
  //       onClick: () => {
  //         store.dispatch(signOut());
  //       },
  //     },
  //   ],
  // },
];

export const paramsToString = (
  user?: User | null,
  params?: ((user: User) => string) | AnyObject | string,
) => {
  if (!user) {
    return "";
  }

  if (typeof params === "string") {
    return "?params";
  }

  if (typeof params === "function") {
    let result = params(user);

    if (result) {
      if (typeof result === "object") {
        result = createSearchParams(result).toString();
      }

      return `?${result}`;
    }

    return "";
  }

  if (params && typeof params === "object") {
    return `?${createSearchParams(params).toString()}`;
  }

  return "";
};

const createItem = (
  {
    route,
    children,
    ignoreMenu,
    privateRoute,
    translationKey,
    ...data
  }: MenuRoute, // Route,
  user: User,
) => {
  let childrenList;

  const navChildGeneralProps: Partial<NavLinkProps> = {
    className: "clip",
    style: {
      maxWidth: "var(--menu-item-max-w)",
      // display: "flex",
      // alignItems: "center",
    },
  };

  // && children.every((item) => !item.hidden)
  if (children && children.length > 0) {
    childrenList = children.filter(
      ({ ignoreMenu: childrenIgnoreMenu }) => childrenIgnoreMenu !== true,
    );

    if (childrenList.length > 0) {
      childrenList = childrenList.map(
        ({
          ignoreMenu: childrenIgnoreMenu,
          privateRoute: childrenPrivateRoute,
          ...child
        }) => {
          const childName =
            typeof child.name === "function" ? child.name(user) : child.name;

          /** If translation key passed - menu will use text from i18n config. If not - use 'name' from route */
          const translatedChildName = child.translationKey
            ? i18n.t(child.translationKey)
            : childName;

          return {
            ...child,
            children: undefined,
            label: child.route ? (
              <NavLink
                to={`/${child.route.path}${paramsToString(user, child.route.path) || ""}`}
                title={translatedChildName} // {child.name || child.key}
                {...navChildGeneralProps}
              >
                {/*{child.name || child.key}*/}
                {translatedChildName}
              </NavLink>
            ) : (
              child.name
            ),
            key: child.route
              ? `/${child.route.path}`
              : `/${child.key || child.name}`,
          };
        },
      );
    }
  }

  const name = typeof data.name === "function" ? data.name(user) : data.name;

  const translatedName = translationKey ? i18n.t(translationKey) : name;

  return {
    ...data,
    children:
      childrenList && childrenList.length > 0 ? childrenList : undefined,
    label:
      route && (childrenList || []).length === 0 ? (
        <NavLink
          to={`/${route.path}${paramsToString(user, route.params) || ""}`}
          title={translatedName} // name
          {...navChildGeneralProps}
        >
          {translatedName}
          {/*{name}*/}
        </NavLink>
      ) : (
        translatedName // name
      ),
    key: route ? `/${route.path}` : `/${data.key || name}`,
  };
};

export const menuLeft = routes
  .filter(({ ignoreMenu }) => ignoreMenu !== true)
  .filter(({ align }) => align === "left");

export const menuRight = routes
  .filter(({ ignoreMenu }) => ignoreMenu !== true)
  .filter(({ align }) => align === "right");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function filter(list: any[], user: User) {
  const newList = list.map((item) => ({
    ...item,
    children: item.children ? [...item.children] : undefined,
  }));

  return newList.filter((item) => {
    if (item && item.children && item.children.length > 0) {
      item.children = filter(item.children, user);
    }

    return item?.roles ? doesUserHaveAccess(item?.roles, user) : true;
  });
}

export interface MenuProps {
  user: User;
}

function Menu({ user }: MenuProps): React.ReactNode {
  const { authorized } = useAuth();
  // const { open, contextHolder } = useSimpleModal();
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  const currentLang = i18n.language;
  const menuLeftFiltered = useMemo(
    () =>
      filter(
        menuLeft.map((data) => createItem(data, user)),
        user,
      ).map((item) => ({
        ...item,
        name: typeof item.name === "function" ? item.name(user) : item.name,
        icon: typeof item.icon === "function" ? item.icon(user) : item.icon,
      })), // .map(({ children, ...item }) => item)
    [user, currentLang],
  );

  // "/" renders the Dashboard screen, so highlight Dashboard there too
  const activeMenuItem =
    pathname === "/" ? "/dashboard" : `/${pathname.split("/")[1]}`;

  return (
    <div className={styles.menu}>
      <AntdMenu
        key={`top-${activeMenuItem}`}
        theme="light"
        mode="inline" // "vertical"
        defaultSelectedKeys={[activeMenuItem]}
        selectedKeys={[activeMenuItem]}
        items={menuLeftFiltered}
      />
      {authorized ? null : <div style={{ padding: 8 }}>Not authorized</div>}
    </div>
  );
}

export default connect((state: RootState) => ({
  user: state[moduleName].user,
}))(Menu);
